import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Partner } from "@/components/landing/Partner";
import { Capabilities } from "@/components/landing/Capabilities";
import { Projects } from "@/components/landing/Projects";
import { About } from "@/components/landing/About";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { useReveal } from "@/lib/useReveal";

export default function Landing() {
    useReveal();
    return (
        <main data-testid="landing-page" className="min-h-screen bg-bone">
            <Header />
            <Hero />
            <Partner />
            <Capabilities />
            <Projects />
            <About />
            <Contact />
            <Footer />
        </main>
    );
}
